import { countries } from '.';
import { generateKeys } from '../utils';
const withdrawalBanks = {
    IDR_002: {
        value: 'IDR_002',
        label: 'Bank Rakyat Indonesia (BRI)',
        country: countries.id,
    },
    IDR_003: {
        value: 'IDR_003',
        label: 'Bank Ekspor Indonesia',
        country: countries.id,
    },
    IDR_008: {
        value: 'IDR_008',
        label: 'Bank Mandiri',
        country: countries.id,
    },
    IDR_009: {
        value: 'IDR_009',
        label: 'Bank BNI',
        country: countries.id,
    },
    IDR_011: {
        value: 'IDR_011',
        label: 'Bank Danamon',
        country: countries.id,
    },
    IDR_013: {
        value: 'IDR_013',
        label: 'Bank Permata',
        country: countries.id,
    },
    IDR_014: {
        value: 'IDR_014',
        label: 'Bank Central Asia (BCA)',
        country: countries.id,
    },
    IDR_016: {
        value: 'IDR_016',
        label: 'Maybank Indonesia',
        country: countries.id,
    },
    IDR_019: {
        value: 'IDR_019',
        label: 'Bank Panin',
        country: countries.id,
    },
    IDR_020: {
        value: 'IDR_020',
        label: 'Bank Arta Niaga Kencana',
        country: countries.id,
    },
    IDR_022: {
        value: 'IDR_022',
        label: 'Bank CIMB Niaga / Bank CIMB Niaga Syariah',
        country: countries.id,
    },
    IDR_023: {
        value: 'IDR_023',
        label: 'Bank UOB Indonesia / Bank Buana Indonesia',
        country: countries.id,
    },
    IDR_026: {
        value: 'IDR_026',
        label: 'Bank Lippo',
        country: countries.id,
    },
    IDR_028: {
        value: 'IDR_028',
        label: 'Bank OCBC NISP',
        country: countries.id,
    },
    IDR_030: {
        value: 'IDR_030',
        label: 'American Express Bank LTD',
        country: countries.id,
    },
    IDR_031: {
        value: 'IDR_031',
        label: 'Citibank Indonesia',
        country: countries.id,
    },
    IDR_032: {
        value: 'IDR_032',
        label: 'JP Morgan Chase Bank',
        country: countries.id,
    },
    IDR_033: {
        value: 'IDR_033',
        label: 'Bank of America',
        country: countries.id,
    },
    IDR_034: {
        value: 'IDR_034',
        label: 'ING Indonesia Bank',
        country: countries.id,
    },
    IDR_036: {
        value: 'IDR_036',
        label: 'Bank Multicor / Bank CCB Indonesia',
        country: countries.id,
    },
    IDR_037: {
        value: 'IDR_037',
        label: 'Bank Artha Graha Internasional',
        country: countries.id,
    },
    IDR_039: {
        value: 'IDR_039',
        label: 'Bank Credit Agricole Indosuez',
        country: countries.id,
    },
    IDR_040: {
        value: 'IDR_040',
        label: 'Bangkok Bank',
        country: countries.id,
    },
    IDR_041: {
        value: 'IDR_041',
        label: 'Bank HSBC Indonesia',
        country: countries.id,
    },
    IDR_042: {
        value: 'IDR_042',
        label: 'Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD',
        country: countries.id,
    },
    IDR_045: {
        value: 'IDR_045',
        label: 'Bank Sumitomo Mitsui Indonesia',
        country: countries.id,
    },
    IDR_046: {
        value: 'IDR_046',
        label: 'Bank DBS Indonesia',
        country: countries.id,
    },
    IDR_047: {
        value: 'IDR_047',
        label: 'Bank Resona Perdania',
        country: countries.id,
    },
    IDR_048: {
        value: 'IDR_048',
        label: 'Bank Mizuho Indonesia',
        country: countries.id,
    },
    IDR_050: {
        value: 'IDR_050',
        label: 'Standard Chartered Bank',
        country: countries.id,
    },
    IDR_052: {
        value: 'IDR_052',
        label: 'Bank ABN Amro',
        country: countries.id,
    },
    IDR_053: {
        value: 'IDR_053',
        label: 'Bank Keppel Tatlee Buana',
        country: countries.id,
    },
    IDR_054: {
        value: 'IDR_054',
        label: 'Bank Capital Indonesia',
        country: countries.id,
    },
    IDR_057: {
        value: 'IDR_057',
        label: 'Bank BNP Paribas Indonesia',
        country: countries.id,
    },
    IDR_059: {
        value: 'IDR_059',
        label: 'Korea Exchange Bank Danamon',
        country: countries.id,
    },
    IDR_060: {
        value: 'IDR_060',
        label: 'Bank Rabobank International Indonesia',
        country: countries.id,
    },
    IDR_061: {
        value: 'IDR_061',
        label: 'Bank ANZ Indonesia',
        country: countries.id,
    },
    IDR_067: {
        value: 'IDR_067',
        label: 'Deutsche Bank',
        country: countries.id,
    },
    IDR_068: {
        value: 'IDR_068',
        label: 'Bank Woori Saudara',
        country: countries.id,
    },
    IDR_069: {
        value: 'IDR_069',
        label: 'Bank of China',
        country: countries.id,
    },
    IDR_076: {
        value: 'IDR_076',
        label: 'Bank Bumi Arta',
        country: countries.id,
    },
    IDR_087: {
        value: 'IDR_087',
        label: 'Bank Ekonomi Raharja',
        country: countries.id,
    },
    IDR_088: {
        value: 'IDR_088',
        label: 'Bank Antardaerah',
        country: countries.id,
    },
    IDR_089: {
        value: 'IDR_089',
        label: 'Bank Haga',
        country: countries.id,
    },
    IDR_093: {
        value: 'IDR_093',
        label: 'Bank IFI',
        country: countries.id,
    },
    IDR_095: {
        value: 'IDR_095',
        label: 'J Trust Bank / Bank Jtrust Indonesia',
        country: countries.id,
    },
    IDR_097: {
        value: 'IDR_097',
        label: 'Bank Mayapada',
        country: countries.id,
    },
    IDR_110: {
        value: 'IDR_110',
        label: 'Bank Jabar / Bank BJB',
        country: countries.id,
    },
    IDR_111: {
        value: 'IDR_111',
        label: 'Bank DKI',
        country: countries.id,
    },
    IDR_112: {
        value: 'IDR_112',
        label: 'BPD Daerah Istimewa Yogyakarta (DIY)',
        country: countries.id,
    },
    IDR_113: {
        value: 'IDR_113',
        label: 'BPD Jawa Tengah',
        country: countries.id,
    },
    IDR_114: {
        value: 'IDR_114',
        label: 'BPD Jawa Timur',
        country: countries.id,
    },
    IDR_115: {
        value: 'IDR_115',
        label: 'BPD Jambi UUS',
        country: countries.id,
    },
    IDR_116: {
        value: 'IDR_116',
        label: 'Bank Aceh Syariah',
        country: countries.id,
    },
    IDR_117: {
        value: 'IDR_117',
        label: 'BPD Sumatra Utara',
        country: countries.id,
    },
    IDR_118: {
        value: 'IDR_118',
        label: 'Bank Nagari / Bank Sumbar',
        country: countries.id,
    },
    IDR_119: {
        value: 'IDR_119',
        label: 'BPD Riau Dan Kepri',
        country: countries.id,
    },
    IDR_120: {
        value: 'IDR_120',
        label: 'BPD Sumsel Dan Babel',
        country: countries.id,
    },
    IDR_121: {
        value: 'IDR_121',
        label: 'BPD Lampung',
        country: countries.id,
    },
    IDR_122: {
        value: 'IDR_122',
        label: 'BPD Kalimantan Selatan',
        country: countries.id,
    },
    IDR_123: {
        value: 'IDR_123',
        label: 'BPD Kalimantan Barat',
        country: countries.id,
    },
    IDR_124: {
        value: 'IDR_124',
        label: 'BPD Kalimantan Timur',
        country: countries.id,
    },
    IDR_125: {
        value: 'IDR_125',
        label: 'BPD Kalimantan Tengah',
        country: countries.id,
    },
    IDR_126: {
        value: 'IDR_126',
        label: 'Bank Sulawesi Selatan Dan Barat',
        country: countries.id,
    },
    IDR_127: {
        value: 'IDR_127',
        label: 'Bank Sulawesi Utara Dan Gorontalo',
        country: countries.id,
    },
    IDR_128: {
        value: 'IDR_128',
        label: 'BPD Nusa Tenggara Barat',
        country: countries.id,
    },
    IDR_129: {
        value: 'IDR_129',
        label: 'BPD Bali',
        country: countries.id,
    },
    IDR_130: {
        value: 'IDR_130',
        label: 'BPD Nusa Tenggara Timur',
        country: countries.id,
    },
    IDR_131: {
        value: 'IDR_131',
        label: 'Bank Maluku Malut',
        country: countries.id,
    },
    IDR_132: {
        value: 'IDR_132',
        label: 'Bank Papua',
        country: countries.id,
    },
    IDR_133: {
        value: 'IDR_133',
        label: 'BPD Bengkulu',
        country: countries.id,
    },
    IDR_134: {
        value: 'IDR_134',
        label: 'BPD Sulawesi Tengah',
        country: countries.id,
    },
    IDR_135: {
        value: 'IDR_135',
        label: 'BPD Sulawesi Tenggara',
        country: countries.id,
    },
    IDR_137: {
        value: 'IDR_137',
        label: 'BPD Banten',
        country: countries.id,
    },
    IDR_145: {
        value: 'IDR_145',
        label: 'Bank Nusantara Parahyangan / BNP',
        country: countries.id,
    },
    IDR_146: {
        value: 'IDR_146',
        label: 'Bank Swadesi (Bank of India Indonesia)',
        country: countries.id,
    },
    IDR_147: {
        value: 'IDR_147',
        label: 'Bank Muamalat Indonesia',
        country: countries.id,
    },
    IDR_151: {
        value: 'IDR_151',
        label: 'Bank Mestika Dharma',
        country: countries.id,
    },
    IDR_152: {
        value: 'IDR_152',
        label: 'Bank Metro Express / Shinhan',
        country: countries.id,
    },
    IDR_153: {
        value: 'IDR_153',
        label: 'Bank Sinarmas',
        country: countries.id,
    },
    IDR_157: {
        value: 'IDR_157',
        label: 'Bank Maspion Indonesia',
        country: countries.id,
    },
    IDR_159: {
        value: 'IDR_159',
        label: 'Bank Hagakita',
        country: countries.id,
    },
    IDR_161: {
        value: 'IDR_161',
        label: 'Bank Ganesha',
        country: countries.id,
    },
    IDR_162: {
        value: 'IDR_162',
        label: 'Bank of Windu Kentjana',
        country: countries.id,
    },
    IDR_164: {
        value: 'IDR_164',
        label: 'Bank ICBC Indonesia',
        country: countries.id,
    },
    IDR_166: {
        value: 'IDR_166',
        label: 'Bank Harmoni International',
        country: countries.id,
    },
    IDR_167: {
        value: 'IDR_167',
        label: 'Bank QNB Indonesia',
        country: countries.id,
    },
    IDR_200: {
        value: 'IDR_200',
        label: 'Bank BTN',
        country: countries.id,
    },
    IDR_212: {
        value: 'IDR_212',
        label: 'Bank Himpunan Saudara 1906',
        country: countries.id,
    },
    IDR_213: {
        value: 'IDR_213',
        label: 'Bank BTPN',
        country: countries.id,
    },
    IDR_333: {
        value: 'IDR_333',
        label: 'Koperasi Intidana',
        country: countries.id,
    },
    IDR_405: {
        value: 'IDR_405',
        label: 'Bank Victoria Syariah / Bank Swaguna',
        country: countries.id,
    },
    IDR_422: {
        value: 'IDR_422',
        label: 'Bank BRI Syariah (BRIS)',
        country: countries.id,
    },
    IDR_425: {
        value: 'IDR_425',
        label: 'Bank BJB Syariah',
        country: countries.id,
    },
    IDR_426: {
        value: 'IDR_426',
        label: 'Bank Mega',
        country: countries.id,
    },
    IDR_427: {
        value: 'IDR_427',
        label: 'Bank BNI Syariah',
        country: countries.id,
    },
    IDR_441: {
        value: 'IDR_441',
        label: 'Bank Bukopin',
        country: countries.id,
    },
    IDR_451: {
        value: 'IDR_451',
        label: 'Bank Syariah Mandiri (BSM)',
        country: countries.id,
    },
    IDR_459: {
        value: 'IDR_459',
        label: 'Bank Bisnis Internasional',
        country: countries.id,
    },
    IDR_466: {
        value: 'IDR_466',
        label: 'Bank Sri Partha / Bank Andara',
        country: countries.id,
    },
    IDR_472: {
        value: 'IDR_472',
        label: 'Bank Jasa Jakarta',
        country: countries.id,
    },
    IDR_484: {
        value: 'IDR_484',
        label: 'Bank KEB Hana Indonesia / Bank Bintang Manunggal',
        country: countries.id,
    },
    IDR_485: {
        value: 'IDR_485',
        label: 'Bank MNC Internasional / Bank Bumiputera',
        country: countries.id,
    },
    IDR_490: {
        value: 'IDR_490',
        label: 'Bank Yudha Bhakti (BYB)',
        country: countries.id,
    },
    IDR_491: {
        value: 'IDR_491',
        label: 'Bank Mitra Niaga',
        country: countries.id,
    },
    IDR_494: {
        value: 'IDR_494',
        label: 'Bank Agroniaga / Bank BRI Agro Niaga',
        country: countries.id,
    },
    IDR_498: {
        value: 'IDR_498',
        label: 'Bank SBI Indonesia / Bank Indo Monex',
        country: countries.id,
    },
    IDR_501: {
        value: 'IDR_501',
        label: 'Royal Bank of Scotland (RBS) / Bank Royal Indonesia',
        country: countries.id,
    },
    IDR_503: {
        value: 'IDR_503',
        label: 'Bank National NOBU / Bank Alfindo',
        country: countries.id,
    },
    IDR_506: {
        value: 'IDR_506',
        label: 'Bank Mega Syariah',
        country: countries.id,
    },
    IDR_513: {
        value: 'IDR_513',
        label: 'Bank Ina Perdania',
        country: countries.id,
    },
    IDR_517: {
        value: 'IDR_517',
        label: 'Panin Dubai Syariah Bank / Bank Harfa',
        country: countries.id,
    },
    IDR_520: {
        value: 'IDR_520',
        label: 'Prima Master Bank',
        country: countries.id,
    },
    IDR_521: {
        value: 'IDR_521',
        label: 'Bank Syariah Bukopin',
        country: countries.id,
    },
    IDR_523: {
        value: 'IDR_523',
        label: 'Bank Sahabat Sampoerna',
        country: countries.id,
    },
    IDR_525: {
        value: 'IDR_525',
        label: 'Bank Barclays / Bank Akita',
        country: countries.id,
    },
    IDR_526: {
        value: 'IDR_526',
        label: 'Bank Dinar / Liman International Bank',
        country: countries.id,
    },
    IDR_531: {
        value: 'IDR_531',
        label: 'Anglomas International Bank',
        country: countries.id,
    },
    IDR_535: {
        value: 'IDR_535',
        label: 'Bank Kesejahteraan Ekonomi',
        country: countries.id,
    },
    IDR_536: {
        value: 'IDR_536',
        label: 'Bank Central Asia (BCA) Syariah',
        country: countries.id,
    },
    IDR_542: {
        value: 'IDR_542',
        label: 'Bank Artos Indonesia',
        country: countries.id,
    },
    IDR_547: {
        value: 'IDR_547',
        label: 'BANK BTPN SYARIAH / BANK PURBA DANARTA',
        country: countries.id,
    },
    IDR_548: {
        value: 'IDR_548',
        label: 'Bank Multiarta Sentosa',
        country: countries.id,
    },
    IDR_553: {
        value: 'IDR_553',
        label: 'Bank Mayora Indonesia',
        country: countries.id,
    },
    IDR_555: {
        value: 'IDR_555',
        label: 'Bank Index Selindo',
        country: countries.id,
    },
    IDR_558: {
        value: 'IDR_558',
        label: 'Bank Eksekutif',
        country: countries.id,
    },
    IDR_559: {
        value: 'IDR_559',
        label: 'Centratama Nasional Bank',
        country: countries.id,
    },
    IDR_562: {
        value: 'IDR_562',
        label: 'Bank Fama Internasional',
        country: countries.id,
    },
    IDR_564: {
        value: 'IDR_564',
        label: 'Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos',
        country: countries.id,
    },
    IDR_566: {
        value: 'IDR_566',
        label: 'Bank Victoria Internasional',
        country: countries.id,
    },
    IDR_567: {
        value: 'IDR_567',
        label: 'Bank Harda Internasional',
        country: countries.id,
    },
    IDR_600: {
        value: 'IDR_600',
        label: 'LSB (Lembaga Selain Bank) / BPR',
        country: countries.id,
    },
    IDR_688: {
        value: 'IDR_688',
        label: 'BPR KS (Karyajatnika Sedaya)',
        country: countries.id,
    },
    IDR_770: {
        value: 'IDR_770',
        label: 'ALTO Pay',
        country: countries.id,
    },
    IDR_775: {
        value: 'IDR_775',
        label: 'SGDO Pay',
        country: countries.id,
    },
    IDR_777: {
        value: 'IDR_777',
        label: 'Finnet',
        country: countries.id,
    },
    IDR_778: {
        value: 'IDR_778',
        label: 'Bank DKI UUS',
        country: countries.id,
    },
    IDR_789: {
        value: 'IDR_789',
        label: 'Indosat (dompetku)',
        country: countries.id,
    },
    IDR_867: {
        value: 'IDR_867',
        label: 'Bank Eka Bumi Artha',
        country: countries.id,
    },
    IDR_899: {
        value: 'IDR_899',
        label: 'Doku',
        country: countries.id,
    },
    IDR_911: {
        value: 'IDR_911',
        label: 'Linkaja / Telcomsel (Tcash)',
        country: countries.id,
    },
    IDR_945: {
        value: 'IDR_945',
        label: 'IBK Bank Indonesia / Bank Finconesia',
        country: countries.id,
    },
    IDR_946: {
        value: 'IDR_946',
        label: 'Bank Merincorp',
        country: countries.id,
    },
    IDR_947: {
        value: 'IDR_947',
        label: 'Bank Maybank Syariah Indonesia',
        country: countries.id,
    },
    IDR_948: {
        value: 'IDR_948',
        label: 'Bank OCBC Indonesia',
        country: countries.id,
    },
    IDR_949: {
        value: 'IDR_949',
        label: 'Bank CTBC Indonesia',
        country: countries.id,
    },
    IDR_950: {
        value: 'IDR_950',
        label: 'Bank Commonwealth',
        country: countries.id,
    },
    IDR_987: {
        value: 'IDR_987',
        label: 'Artajasa / ATMB Plus',
        country: countries.id,
    },
    CNYDUMMYBANK1: {
        value: 'CNYDUMMYBANK1',
        label: 'DummyCNYBank',
        country: countries.in,
    },
    INRDUMMYBANK1: {
        value: 'INRDUMMYBANK1',
        label: 'DummyINRBank',
        country: countries.in,
    },
    AXIS: {
        value: 'AXIS',
        label: 'Axis Bank',
        country: countries.in,
    },
    BRDA: {
        value: 'BRDA',
        label: 'Bank of Baroda',
        country: countries.in,
    },
    BOIN: {
        value: 'BOIN',
        label: 'Bank of India',
        country: countries.in,
    },
    CANBK: {
        value: 'CANBK',
        label: 'Canara Bank',
        country: countries.in,
    },
    CBOI: {
        value: 'CBOI',
        label: 'Central Bank of India',
        country: countries.in,
    },
    HDFC: {
        value: 'HDFC',
        label: 'HDFC Bank',
        country: countries.in,
    },
    ICICI: {
        value: 'ICICI',
        label: 'ICICI Bank',
        country: countries.in,
    },
    IDBI: {
        value: 'IDBI',
        label: 'IDBI Bank',
        country: countries.in,
    },
    INDNB: {
        value: 'INDNB',
        label: 'Indian Bank',
        country: countries.in,
    },
    KARBK: {
        value: 'KARBK',
        label: 'Karnataka Bank',
        country: countries.in,
    },
    KOTBK: {
        value: 'KOTBK',
        label: 'Kotak Mahindra Bank',
        country: countries.in,
    },
    PNJB: {
        value: 'PNJB',
        label: 'Punjab National Bank',
        country: countries.in,
    },
    SCTRD: {
        value: 'SCTRD',
        label: 'Standard Chartered Bank',
        country: countries.in,
    },
    SBIN: {
        value: 'SBIN',
        label: 'State Bank of India',
        country: countries.in,
    },
    UNBOI: {
        value: 'UNBOI',
        label: 'Union Bank of India',
        country: countries.in,
    },
    YESB: {
        value: 'YESB',
        label: 'Yes Bank',
        country: countries.in,
    },
    ALHB: {
        value: 'ALHB',
        label: 'Allahabad Bank',
        country: countries.in,
    },
    ANDB: {
        value: 'ANDB',
        label: 'Andhra Bank',
        country: countries.in,
    },
    MHRT: {
        value: 'MHRT',
        label: 'Bank of Maharashtra',
        country: countries.in,
    },
    CSYB: {
        value: 'CSYB',
        label: 'Catholic Syrian Bank',
        country: countries.in,
    },
    CITI: {
        value: 'CITI',
        label: 'Citi Bank',
        country: countries.in,
    },
    CORB: {
        value: 'CORB',
        label: 'Corporation Bank',
        country: countries.in,
    },
    DENB: {
        value: 'DENB',
        label: 'Dena Bank',
        country: countries.in,
    },
    DNLM: {
        value: 'DNLM',
        label: 'Dhanlaxmi Bank',
        country: countries.in,
    },
    FEDB: {
        value: 'FEDB',
        label: 'Federal Bank',
        country: countries.in,
    },
    INOB: {
        value: 'INOB',
        label: 'Indian Overseas Bank',
        country: countries.in,
    },
    INDU: {
        value: 'INDU',
        label: 'IndusInd Bank',
        country: countries.in,
    },
    JAKB: {
        value: 'JAKB',
        label: 'Jammu and Kashmir Bank',
        country: countries.in,
    },
    OBOC: {
        value: 'OBOC',
        label: 'Oriental Bank of Commerce',
        country: countries.in,
    },
    PASB: {
        value: 'PASB',
        label: 'Punjab and Sind Bank',
        country: countries.in,
    },
    SBBJ: {
        value: 'SBBJ',
        label: 'State Bank of Bikaner and Jaipur',
        country: countries.in,
    },
    SBOH: {
        value: 'SBOH',
        label: 'State Bank of Hyderabad',
        country: countries.in,
    },
    SBOT: {
        value: 'SBOT',
        label: 'State Bank of Travancore',
        country: countries.in,
    },
    SIBK: {
        value: 'SIBK',
        label: 'South Indian Bank',
        country: countries.in,
    },
    SYNB: {
        value: 'SYNB',
        label: 'Syndicate Bank',
        country: countries.in,
    },
    TAMB: {
        value: 'TAMB',
        label: 'Tamilnadu Mercantile Bank',
        country: countries.in,
    },
    UCOB: {
        value: 'UCOB',
        label: 'UCO Bank',
        country: countries.in,
    },
    VJYB: {
        value: 'VJYB',
        label: 'Vijaya Bank',
        country: countries.in,
    },
    GPAYQR: {
        value: 'GPAYQR',
        label: 'Google Pay',
        country: countries.in,
    },
    IMPS: {
        value: 'IMPS',
        label: 'IMPS',
        country: countries.in,
    },
    UPIQR: {
        value: 'UPIQR',
        label: 'UPI',
        country: countries.in,
    },
    CN_CIB: {
        value: 'CN_CIB',
        label: 'China Industrial Bank',
        country: countries.cn,
    },
    CN_CGB: {
        value: 'CN_CGB',
        label: 'China Guangfa Bank',
        country: countries.cn,
    },
    CN_CMB: {
        value: 'CN_CMB',
        label: 'China Merchants Bank',
        country: countries.cn,
    },
    CN_PSBC: {
        value: 'CN_PSBC',
        label: 'China Postal Savings Bank',
        country: countries.cn,
    },
    CN_BOC: {
        value: 'CN_BOC',
        label: 'Bank of China',
        country: countries.cn,
    },
    CN_ABC: {
        value: 'CN_ABC',
        label: 'Agricultural Bank of China',
        country: countries.cn,
    },
    CN_CEB: {
        value: 'CN_CEB',
        label: 'China Everbright Bank',
        country: countries.cn,
    },
    CN_CCB: {
        value: 'CN_CCB',
        label: 'China Construction Bank',
        country: countries.cn,
    },
    CN_PAB: {
        value: 'CN_PAB',
        label: 'Ping An Bank',
        country: countries.cn,
    },
    CN_BCOM: {
        value: 'CN_BCOM',
        label: 'Bank of Communication',
        country: countries.cn,
    },
    CN_ICBC: {
        value: 'CN_ICBC',
        label: 'Industrial and Commercial Bank of China',
        country: countries.cn,
    },
    CN_SPDB: {
        value: 'CN_SPDB',
        label: 'Shanghai Pudong Development Bank',
        country: countries.cn,
    },
    CN_CMBC: {
        value: 'CN_CMBC',
        label: 'China Minsheng Bank',
        country: countries.cn,
    },
    CN_CITIC: {
        value: 'CN_CITIC',
        label: 'China CITIC Bank',
        country: countries.cn,
    },
    TH_BANGKOK: {
        value: 'TH_BANGKOK',
        label: 'Bangkok Bank',
        country: countries.th,
    },
    TH_TTBDIRECT: {
        value: 'TH_TTBDIRECT',
        label: 'TTB Bank',
        country: countries.th,
    },
    TH_KRUNGSRI: {
        value: 'TH_KRUNGSRI',
        label: 'Bank of Ayudhya (Krungsri)',
        country: countries.th,
    },
    TH_CIMB: {
        value: 'TH_CIMB',
        label: 'CIMB Clicks Thai Bank',
        country: countries.th,
    },
    TH_GOVERNMENTSAVINGS: {
        value: 'TH_GOVERNMENTSAVINGS',
        label: 'Government Savings Bank',
        country: countries.th,
    },
    TH_KASIKORN: {
        value: 'TH_KASIKORN',
        label: 'Kasikorn Bank',
        country: countries.th,
    },
    TH_KRUNGTHAI: {
        value: 'TH_KRUNGTHAI',
        label: 'Krung Thai Bank',
        country: countries.th,
    },
    TH_SIAM: {
        value: 'TH_SIAM',
        label: 'Siam Commercial Bank',
        country: countries.th,
    },
    TH_UOBT: {
        value: 'TH_UOBT',
        label: 'United Overseas Bank',
        country: countries.th,
    },
    MY_CIMB: {
        value: 'MY_CIMB',
        label: 'CIMB Clicks Bank',
        country: countries.my,
    },
    MY_AMB: {
        value: 'MY_AMB',
        label: 'AM Bank',
        country: countries.my,
    },
    MY_HLB: {
        value: 'MY_HLB',
        label: 'Hong Leong Bank',
        country: countries.my,
    },
    MY_MAYB: {
        value: 'MY_MAYB',
        label: 'Maybank',
        country: countries.my,
    },
    MY_PUBLIC: {
        value: 'MY_PUBLIC',
        label: 'Public Bank',
        country: countries.my,
    },
    MY_RHB: {
        value: 'MY_RHB',
        label: 'RHB Bank',
        country: countries.my,
    },
    MY_OCBC: {
        value: 'MY_OCBC',
        label: 'OCBC Bank',
        country: countries.my,
    },
    VN_ACB: {
        value: 'VN_ACB',
        label: 'AC Bank',
        country: countries.vn,
    },
    VN_SACOM: {
        value: 'VN_SACOM',
        label: 'Sacom Bank',
        country: countries.vn,
    },
    VN_VIETCOM: {
        value: 'VN_VIETCOM',
        label: 'Vietcom Bank',
        country: countries.vn,
    },
    VN_TECHCOM: {
        value: 'VN_TECHCOM',
        label: 'Techcom Bank',
        country: countries.vn,
    },
    VN_DONGA: {
        value: 'VN_DONGA',
        label: 'DongA Bank',
        country: countries.vn,
    },
};
export const echelonpayDepositBanks = generateKeys(withdrawalBanks);
